"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDiff = void 0;
const changeTypeMap = {
    '+': 'ADDED',
    '-': 'DELETED',
    '~': 'EDITED',
};
const handleArrayDiff = (arrayDiff, path, changes) => {
    arrayDiff.forEach(([op, value]) => {
        const changeType = changeTypeMap[op];
        if (!changeType)
            return;
        if (typeof value === 'object' && value !== null) {
            parseDiffRecursive(value, path, changes);
        }
        else {
            const change = { path, type: changeType };
            if (changeType === 'ADDED') {
                change.newValue = value;
            }
            else if (changeType === 'DELETED') {
                change.oldValue = value;
            }
            changes.push(change);
        }
    });
};
const handleObject = (key, value, path, isRoot, changes) => {
    const currentPath = path ? `${path}.${key}` : key;
    if (isRoot && key.endsWith('__added')) {
        const actualKey = key.slice(0, -'__added'.length);
        const finalPath = path ? `${path}.${actualKey}` : actualKey;
        changes.push({ path: finalPath, type: 'ADDED', newValue: value });
        return;
    }
    if (isRoot && key.endsWith('__deleted')) {
        const actualKey = key.slice(0, -'__deleted'.length);
        const finalPath = path ? `${path}.${actualKey}` : actualKey;
        changes.push({ path: finalPath, type: 'DELETED', oldValue: value });
        return;
    }
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if ('__old' in value && '__new' in value) {
            changes.push({
                path: currentPath,
                type: 'EDITED',
                oldValue: value.__old,
                newValue: value.__new,
            });
        }
        else {
            parseDiffRecursive(value, currentPath, changes);
        }
    }
    else if (Array.isArray(value)) {
        handleArrayDiff(value, currentPath, changes);
    }
    else {
        changes.push({
            path: currentPath,
            type: 'EDITED',
            oldValue: undefined,
            newValue: value,
        });
    }
};
const parseDiffRecursive = (current, path, changes) => {
    Object.entries(current).forEach(([key, value]) => {
        handleObject(key, value, path, false, changes);
    });
};
const parseDiff = (diff) => {
    const changes = [];
    Object.entries(diff).forEach(([key, value]) => {
        handleObject(key, value, '', true, changes);
    });
    return changes;
};
exports.parseDiff = parseDiff;
